var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.927 15.04L18.4001 18.4M9.4001 5.20001C11.3883 5.20001 13.0001 6.81178 13.0001 8.80001M17.2801 9.44001C17.2801 13.7699 13.77 17.28 9.4401 17.28C5.11018 17.28 1.6001 13.7699 1.6001 9.44001C1.6001 5.11009 5.11018 1.60001 9.4401 1.60001C13.77 1.60001 17.2801 5.11009 17.2801 9.44001Z",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.5de1cc4000045796302d7a9dcab4e43e.svg";
export { ForwardRef as ReactComponent };